/* Twinkle Christmas — LED curtain simulator (section "LED message simulator").
   Draws a 16×16 (or 20×20) grid of LEDs on a canvas: scrolling text or pixel drawings. */
(function () {
  'use strict';

  /* 5×7 font, rows top → bottom */
  var F = {
    A: ['.###.', '#...#', '#...#', '#####', '#...#', '#...#', '#...#'],
    B: ['####.', '#...#', '#...#', '####.', '#...#', '#...#', '####.'],
    C: ['.###.', '#...#', '#....', '#....', '#....', '#...#', '.###.'],
    D: ['####.', '#...#', '#...#', '#...#', '#...#', '#...#', '####.'],
    E: ['#####', '#....', '#....', '####.', '#....', '#....', '#####'],
    F: ['#####', '#....', '#....', '####.', '#....', '#....', '#....'],
    G: ['.###.', '#...#', '#....', '#.###', '#...#', '#...#', '.####'],
    H: ['#...#', '#...#', '#...#', '#####', '#...#', '#...#', '#...#'],
    I: ['.###.', '..#..', '..#..', '..#..', '..#..', '..#..', '.###.'],
    J: ['..###', '...#.', '...#.', '...#.', '...#.', '#..#.', '.##..'],
    K: ['#...#', '#..#.', '#.#..', '##...', '#.#..', '#..#.', '#...#'],
    L: ['#....', '#....', '#....', '#....', '#....', '#....', '#####'],
    M: ['#...#', '##.##', '#.#.#', '#.#.#', '#...#', '#...#', '#...#'],
    N: ['#...#', '#...#', '##..#', '#.#.#', '#..##', '#...#', '#...#'],
    O: ['.###.', '#...#', '#...#', '#...#', '#...#', '#...#', '.###.'],
    P: ['####.', '#...#', '#...#', '####.', '#....', '#....', '#....'],
    Q: ['.###.', '#...#', '#...#', '#...#', '#.#.#', '#..#.', '.##.#'],
    R: ['####.', '#...#', '#...#', '####.', '#.#..', '#..#.', '#...#'],
    S: ['.####', '#....', '#....', '.###.', '....#', '....#', '####.'],
    T: ['#####', '..#..', '..#..', '..#..', '..#..', '..#..', '..#..'],
    U: ['#...#', '#...#', '#...#', '#...#', '#...#', '#...#', '.###.'],
    V: ['#...#', '#...#', '#...#', '#...#', '#...#', '.#.#.', '..#..'],
    W: ['#...#', '#...#', '#...#', '#.#.#', '#.#.#', '#.#.#', '.#.#.'],
    X: ['#...#', '#...#', '.#.#.', '..#..', '.#.#.', '#...#', '#...#'],
    Y: ['#...#', '#...#', '.#.#.', '..#..', '..#..', '..#..', '..#..'],
    Z: ['#####', '....#', '...#.', '..#..', '.#...', '#....', '#####'],
    '0': ['.###.', '#...#', '#..##', '#.#.#', '##..#', '#...#', '.###.'],
    '1': ['..#..', '.##..', '..#..', '..#..', '..#..', '..#..', '.###.'],
    '2': ['.###.', '#...#', '....#', '...#.', '..#..', '.#...', '#####'],
    '3': ['#####', '...#.', '..#..', '...#.', '....#', '#...#', '.###.'],
    '4': ['...#.', '..##.', '.#.#.', '#..#.', '#####', '...#.', '...#.'],
    '5': ['#####', '#....', '####.', '....#', '....#', '#...#', '.###.'],
    '6': ['..##.', '.#...', '#....', '####.', '#...#', '#...#', '.###.'],
    '7': ['#####', '....#', '...#.', '..#..', '.#...', '.#...', '.#...'],
    '8': ['.###.', '#...#', '#...#', '.###.', '#...#', '#...#', '.###.'],
    '9': ['.###.', '#...#', '#...#', '.####', '....#', '...#.', '.##..'],
    '!': ['#', '#', '#', '#', '#', '.', '#'],
    '?': ['.###.', '#...#', '....#', '...#.', '..#..', '.....', '..#..'],
    '.': ['.', '.', '.', '.', '.', '.', '#'],
    ',': ['..', '..', '..', '..', '..', '.#', '#.'],
    '-': ['....', '....', '....', '####', '....', '....', '....'],
    "'": ['#', '#', '.', '.', '.', '.', '.'],
    '&': ['.##..', '#..#.', '#.#..', '.#...', '#.#.#', '#..#.', '.##.#'],
    '+': ['.....', '..#..', '..#..', '#####', '..#..', '..#..', '.....'],
    '*': ['.....', '#.#.#', '.###.', '#####', '.###.', '#.#.#', '.....'],
    '♥': ['.#.#.', '#####', '#####', '#####', '.###.', '..#..', '.....'],
    ' ': ['...', '...', '...', '...', '...', '...', '...']
  };

  /* 16×16 drawings: g green, y gold, r red, b brown, w white */
  var ART = {
    tree: ['.......yy.......', '......yyyy......', '.......yy.......', '......gggg......', '.....ggrggg.....', '....ggggggyg....', '.....gggggg.....', '....ggyggggr....',
           '...gggggggggg...', '....grgggggg....', '..gggggyggggrg..', '..gggggggggggg..', '.gggrgggggggygg.', '.......bb.......', '.......bb.......', '......bbbb......'],
    heart: ['................', '................', '..rrrr....rrrr..', '.rrrrrr..rrrrrr.', 'rrwrrrrrrrrrrrrr', 'rwrrrrrrrrrrrrrr', 'rrrrrrrrrrrrrrrr', '.rrrrrrrrrrrrrr.',
            '..rrrrrrrrrrrr..', '...rrrrrrrrrr...', '....rrrrrrrr....', '.....rrrrrr.....', '......rrrr......', '.......rr.......', '................', '................'],
    snow: ['.......ww.......', '.....w.ww.w.....', '......wwww......', '..w....ww....w..', '...w...ww...w...', '....w..ww..w....', '.....w.ww.w.....', 'wwwwwwwwwwwwwwww',
           'wwwwwwwwwwwwwwww', '.....w.ww.w.....', '....w..ww..w....', '...w...ww...w...', '..w....ww....w..', '......wwww......', '.....w.ww.w.....', '.......ww.......'],
    star: ['.......yy.......', '.......yy.......', '......yyyy......', '......yyyy......', 'yyyyyyyyyyyyyyyy', '.yyyyyyyyyyyyyy.', '..yyyyyyyyyyyy..', '...yyyyyyyyyy...',
           '....yyyyyyyy....', '....yyyyyyyy....', '...yyyyyyyyyy...', '...yyyy..yyyy...', '..yyyy....yyyy..', '..yyy......yyy..', '.yy..........yy.', '................']
  };
  var ART_COL = { g: '#2fd35a', y: '#ffcc4d', r: '#ff3347', b: '#c27a3a', w: '#e8f6ff' };
  var XMAS = ['#ff3347', '#ffcc4d', '#2fd35a'];

  function normalize(str) {
    str = (str || '').toString().toUpperCase();
    try { str = str.normalize('NFD').replace(/[̀-ͯ]/g, ''); } catch (e) {}
    return str.replace(/<3/g, '♥');
  }

  function textColumns(str, pad) {
    var cols = [];
    var i, x, y;
    for (i = 0; i < pad; i++) cols.push({ bits: null, ch: -1 });
    var chars = Array.from ? Array.from(normalize(str)) : normalize(str).split('');
    var idx = 0;
    chars.forEach(function (c) {
      var g = F[c];
      if (!g) return;
      var w = g[0].length;
      for (x = 0; x < w; x++) {
        var bits = [];
        for (y = 0; y < 7; y++) bits.push(g[y].charAt(x) === '#');
        cols.push({ bits: bits, ch: c === ' ' ? -1 : idx });
      }
      cols.push({ bits: null, ch: -1 });
      if (c !== ' ') idx++;
    });
    for (i = 0; i < pad; i++) cols.push({ bits: null, ch: -1 });
    return cols;
  }

  function init(root) {
    var canvas = root.querySelector('[data-led-canvas]');
    if (!canvas || !canvas.getContext) return;
    root.classList.add('is-live');
    var ctx = canvas.getContext('2d');
    var N = parseInt(root.getAttribute('data-led-size'), 10) || 16;
    var input = root.querySelector('[data-led-input]');
    var state = { mode: 'text', art: null, palette: 'xmas', offset: 0, cols: textColumns(root.getAttribute('data-led-text') || 'MERRY XMAS', N), t0: 0 };
    var running = false, raf = 0, last = 0, visible = true;

    function resize() {
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      var w = canvas.clientWidth;
      canvas.width = Math.round(w * dpr);
      canvas.height = Math.round(w * dpr);
    }

    function colorFor(x, y, t, base, ch) {
      switch (state.palette) {
        case 'rainbow': return 'hsl(' + Math.round((x * 22 + y * 6 + t / 12) % 360) + ',100%,62%)';
        case 'warm': return '#ffcf7a';
        case 'ice': return (x + y) % 5 === 0 ? '#ffffff' : '#9fdcff';
        default: return base || XMAS[(ch < 0 ? 0 : ch) % 3];
      }
    }

    function draw(t) {
      var W = canvas.width, cell = W / N, r = cell * 0.26;
      ctx.clearRect(0, 0, W, W);
      var top = Math.floor((N - 7) / 2);
      for (var y = 0; y < N; y++) {
        for (var x = 0; x < N; x++) {
          var lit = false, col = null;
          if (state.mode === 'text') {
            var c = state.cols[(state.offset + x) % state.cols.length];
            var ry = y - top;
            if (c && c.bits && ry >= 0 && ry < 7 && c.bits[ry]) { lit = true; col = colorFor(x, y, t, null, c.ch); }
          } else {
            var a = ART[state.art];
            var ax = x - Math.floor((N - 16) / 2), ay = y - Math.floor((N - 16) / 2);
            var k = a && ay >= 0 && ay < 16 && ax >= 0 && ax < 16 ? a[ay].charAt(ax) : '.';
            if (k !== '.') { lit = true; col = colorFor(x, y, t, ART_COL[k], 0); }
          }
          var cx = (x + 0.5) * cell, cy = (y + 0.5) * cell;
          ctx.beginPath();
          if (lit) {
            var tw = state.mode === 'art' ? 0.75 + 0.25 * Math.sin(t / 260 + x * 1.7 + y * 2.3) : 1;
            ctx.globalAlpha = tw;
            ctx.shadowBlur = cell * 0.9;
            ctx.shadowColor = col;
            ctx.fillStyle = col;
            ctx.arc(cx, cy, r * 1.25, 0, Math.PI * 2);
          } else {
            ctx.globalAlpha = 1;
            ctx.shadowBlur = 0;
            ctx.fillStyle = 'rgba(255,240,220,.10)';
            ctx.arc(cx, cy, r * 0.75, 0, Math.PI * 2);
          }
          ctx.fill();
        }
      }
      ctx.globalAlpha = 1;
      ctx.shadowBlur = 0;
    }

    function frame(t) {
      raf = 0;
      if (!running) return;
      if (!last) last = t;
      if (state.mode === 'text' && t - last > 95) { state.offset = (state.offset + 1) % state.cols.length; last = t; }
      draw(t);
      raf = requestAnimationFrame(frame);
    }
    function start() { if (!running && visible) { running = true; last = 0; raf = requestAnimationFrame(frame); } }
    function stop() { running = false; if (raf) cancelAnimationFrame(raf); raf = 0; }

    function showText(txt) {
      state.mode = 'text';
      state.cols = textColumns(txt && txt.trim() ? txt : (root.getAttribute('data-led-text') || ' '), N);
      state.offset = 0;
      setActive('[data-led-art]', null);
    }
    function setActive(sel, el) {
      Array.prototype.forEach.call(root.querySelectorAll(sel), function (b) { b.classList.toggle('is-active', b === el); });
    }

    if (input) {
      input.addEventListener('input', function () { showText(input.value); });
      input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); showText(input.value); } });
    }
    Array.prototype.forEach.call(root.querySelectorAll('[data-led-play]'), function (b) {
      b.addEventListener('click', function () { showText(input ? input.value : ''); });
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-led-art]'), function (b) {
      b.addEventListener('click', function () { state.mode = 'art'; state.art = b.getAttribute('data-led-art'); setActive('[data-led-art]', b); });
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-led-color]'), function (b) {
      b.addEventListener('click', function () { state.palette = b.getAttribute('data-led-color'); setActive('[data-led-color]', b); });
    });

    resize();
    window.addEventListener('resize', function () { resize(); if (!running) draw(performance.now()); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { visible = en[0].isIntersecting; if (visible) start(); else stop(); }).observe(root);
    }
    draw(0);
    start();
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-led-sim]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target && e.target.querySelector && e.target.querySelector('[data-led-sim]');
    if (el) init(el);
  });
})();
